// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TPublicOfferAcceptModel,
  IMappers,
  TPublicOfferAcceptResponse,
  IPublicOfferAcceptResponse,
  IPublicOfferAcceptResponseError,
} from './types';

export const defaultConfig: TPublicOfferAcceptModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'dailyrent',
  pathApi: '/v1/public-offer/accept/',
} as TPublicOfferAcceptModel;

export function createPublicOfferAcceptModel(): TPublicOfferAcceptModel {
  return {
    ...defaultConfig,
  };
}

export interface IPublicOfferAcceptOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchPublicOfferAccept<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IPublicOfferAcceptOptions<TResponse200, TResponse400>): Promise<
  TPublicOfferAcceptResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createPublicOfferAcceptModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicOfferAcceptResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicOfferAcceptResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicOfferAcceptResponse;
}
